<template>
    <div>
        <v-table density="compact" class="text-caption overflow-hidden">
            <tbody>
                <tr align="right">
                    <th>Duration</th>
                    <td>{{ entityRecord.totalTimeMinutes }} minutes</td>
                </tr>
                <tr align="right">
                    <th>Questions</th>
                    <td>{{ entityRecord.questionCount }}</td>
                </tr>
                <tr v-if="entityRecord.welcomeMessage" align="right">
                    <th>Welcome Message</th>
                    <td class="text-wrap">{{ entityRecord.welcomeMessage }}</td>
                </tr>
                <tr align="right">
                    <th>Created</th>
                    <td>{{ entityRecord.dateCreated }}</td>
                </tr>
            </tbody>
        </v-table>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'QuizDetailsPanel',
    computed: {
        ...mapState({
            entityRecord: state => state.entities.entityRecord
        })
    }
};
</script>
